import type { User } from '@wix/ambassador-identity-account-v2-account/types';

export type UserSlice = {
  user: User | null;
  isWixStudioUser: boolean;
  isWixEmployee: boolean;
  loggedInAccountId?: string | null;
};

export const getUserInitialState = (): UserSlice => ({
  user: null,
  isWixStudioUser: false,
  isWixEmployee: false,
  loggedInAccountId: null,
});
